var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcodeBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 89,
    viewBox: "0 0 85 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3672 88.9997V87.7871H83.6539V75.9746H84.8126V88.9997H72.3672Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000460625 75.9785L1.15972 75.9785L1.15972 87.785L12.4521 87.785L12.4521 88.9971L0.000460081 88.9971L0.000460625 75.9785Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4186 42.5231H20.1609V35.2451H16.6845V38.8839H13.208V42.5224H16.6845H13.208V53.4393H16.6845H20.3315V49.8006H16.6845V46.1616H39.9937V70.7357H43.4701V42.5231H41.4186Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2039 35.2451H6.25098V38.8833H13.2039V35.2451Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.993 38.8848H33.04V42.5232H39.993V38.8848Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0397 35.2451H26.0869V38.8833H33.0397V35.2451Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5164 15.1064H33.04V21.6078H36.5164V15.1064Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0887 11.3887H39.6123V18.7452H43.0887V11.3887Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9463 38.8848H43.4697V42.5232H46.9463V38.8848Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8439 42.165H50.3672V51.7679H53.8439V42.165Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4695 35.2451H39.9932V38.8833H43.4695V35.2451Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4226 35.2459V31.6074H43.4697V35.2459H50.4226Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0899 53.4405H50.3647V51.7688H46.8887V61.4913H50.3647V57.0787H53.6514V60.7165H57.1279V57.1361H60.5664V49.4414H57.0899V53.4405Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5203 74.375H64.0439V78.0133H67.5203V74.375Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.389 67.6211H32.9121V82.1747H36.389V74.3753H39.9929V70.7367H36.389V67.6211Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4736 56.9287H6.35645V81.6529H29.9785V78.0135H29.9502V60.5677H29.9785V56.9287H26.4736ZM26.4736 78.013H9.83265V60.5677H26.4736V78.013Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4713 78.0127H67.5186V81.6514H74.4713V78.0127Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2979 78.0533V81.692H57.7744V74.415H54.2979V78.0533Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0495 78.0127H39.9932V81.6514H51.0495V78.0127Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0439 45.8047H60.5674V49.443H64.0439V45.8047Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5203 42.165H64.0439V45.8035H67.5203V42.165Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8738 34.8896H66.7783V38.5281H73.8738V34.8896Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2078 49.8598V42.583H73.7313V46.2213H70.2549V49.8598H77.2078Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2549 49.8604H66.7783V53.4985H70.2549V49.8604Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7313 53.498H70.2549V57.1365H73.7313V53.498Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7313 68.0524V74.3747H77.2078V63.679H73.7313V60.7754H70.2549V68.0524H73.7313Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5673 67.0984H51.0498V70.7374H60.5673V74.3754H64.0439V60.776H70.2557V57.1377H60.5673V67.0984Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0497 70.7373H43.4697V74.3756H51.0497V70.7373Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2832 49.6406V53.4395H32.9131V60.7163H36.3897V53.4388H32.9131V49.6406H29.2832Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3676 63.8467H12.9668V74.7323H23.3676V63.8467Z",
    fill: "#B1C7FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4736 31.606H29.9785V27.9677H29.9502V10.5226H29.9785V6.88379H6.35645V31.606H26.4736ZM9.83265 10.5226H26.4736V27.9684H9.83265V10.5226Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3676 13.8018H12.9668V24.6874H23.3676V13.8018Z",
    fill: "#B1C7FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5929 10.5226V6.88379H53.9705V15.107H46.394V18.7455H43.0889V24.4716H39.993V21.6085H36.5166V24.4716H33.04V35.2468H36.5166V28.1105H46.5654V18.7455H53.9705V31.606H60.5669V38.5271H53.8703V42.1656H64.0433V31.606H77.5927V27.9677H77.564V10.5226H77.5929ZM74.0877 27.9684H57.4473V10.5226H74.0883L74.0877 27.9684Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9818 13.8018H60.5811V24.6874H70.9818V13.8018Z",
    fill: "#B1C7FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8126 13.0249H83.6539V1.21248H72.3672V0H84.8126V13.0249Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4726 0V1.2123H1.18586V13.0248H0.0273438V0H12.4726Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeBlue);
export default __webpack_public_path__ + "static/media/qrcode-blue.8469cd52df323b294b8847bc890b545f.svg";
export { ForwardRef as ReactComponent };